import { CssBaseline, ThemeProvider } from '@mui/material';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import defaultTheme from './themes/default.theme';
import './styles/global.css';
import { SnackbarProvider } from 'notistack';
import { GlobalContextProvider } from '@utils/RequestContext';
import { TimerProvider } from '@utils/TimerContext';
import { bootstrapAuth } from '@auth/bootstrap-auth';

function renderApp(): void {
	ReactDOM.render(
		<BrowserRouter>
			<CssBaseline />
			<ThemeProvider theme={defaultTheme}>
				<SnackbarProvider
					preventDuplicate
					anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
					maxSnack={3}
				>
					<GlobalContextProvider>
						<TimerProvider>
							<App />
						</TimerProvider>
					</GlobalContextProvider>
				</SnackbarProvider>
			</ThemeProvider>
		</BrowserRouter>,
		document.getElementById('root')
	);
}

// Keycloak debe terminar init (incl. #code= del callback) antes del primer render.
bootstrapAuth()
	.catch((error) => {
		console.error('Bootstrap auth falló', error);
	})
	.finally(renderApp);

reportWebVitals();
